import { render, staticRenderFns } from "./recommend_record.vue?vue&type=template&id=8feaa21c&scoped=true"
import script from "./recommend_record.vue?vue&type=script&lang=ts"
export * from "./recommend_record.vue?vue&type=script&lang=ts"
import style0 from "./recommend_record.vue?vue&type=style&index=0&id=8feaa21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feaa21c",
  null
  
)

export default component.exports